import * as actionTypes from "../constants/actionTypes";
import * as license from "../constants/license";
import * as modelHelper from "../helpers/modelHelper";

const initialState = {
    uuid: null,
    licensed: false,
    processStep: 0,
    onlineActivation: false,
    companyId: null,
    userId: null,
    product: null,
    data: null,
    request: null,
    productListOrder: [],
    productList: [],
    registrationData: modelHelper.getEmptyRegistrationObject(),
    licenseStatus: license.STATUS_UNKNOWN,
    licenseExpiration: null,
    licenseLastUpdate: null,
    licenseRemaining: null,
    errorCode: null,
    userName: null,
    userEmail: null,
    companyName: null
};

/**
 * Structure of license store:
 * - uuid {String}
 * - licensed {Boolean}
 * - processStep {Number}
 * - onlineActivation {Boolean}
 * - companyId {String}
 * - userId {String}
 * - product {Object}
 * - data {Object}
 * - request {String}
 * - productList {Array}
 * - registrationData {Object}
 * - licenseStatus {Number}
 * - licenseExpiration {String}
 * - licenseRemaining {Number}
 * - errorCode {Number}
 * - userName {String}
 * - userEmail {String}
 * - companyName {String}
 */
export const licenseReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.LICENSE_SAVE_INFO:
            return {
                ...state,
                uuid: action.payload.data.uuid,
                userName: action.payload.data.userName,
                userEmail: action.payload.data.userEmail,
                companyName: action.payload.data.companyName
            };
        case actionTypes.LICENSE_SET_PROCESS_STEP:
            return {
                ...state,
                processStep: action.payload.step
            };
        case actionTypes.SERVER_IS_LICENSED:
        case actionTypes.SERVER_IS_LICENSED_COMPACT:
            return {
                ...state,
                processStep: 0,
                licenseStatus: action.payload.status,
                licenseExpiration: action.payload.expiration,
                licenseLastUpdate: action.payload.licenseLastUpdate,
                licenseRemaining: action.payload.remaining
            };
        case actionTypes.SOFTWARE_START_INITIALIZATION:
            return {
                ...state,
                licensed: true
            };
        case actionTypes.SERVER_NOT_LICENSED:
            return {
                ...state,
                processStep: 0,
                uuid: null,
                licensed: false
            };
        case actionTypes.LICENSE_SAVE_ONLINE_ACTIVATION_FOR_WIZARD:
            return {
                ...state,
                processStep: 1,
                onlineActivation: action.payload.available
            };
        case actionTypes.LICENSE_SAVE_ONLINE_ACTIVATION:
            return {
                ...state,
                onlineActivation: action.payload.available
            };
        case actionTypes.LICENSE_SAVE_REQUEST:
            return {
                ...state,
                request: action.payload.request
            };
        case actionTypes.LICENSE_SET_IDENTIFICATION:
            return {
                ...state,
                companyId: action.payload.companyId,
                userId: action.payload.userId
            };
        case actionTypes.LICENSE_DELETE_IDENTIFICATION:
            return {
                ...state,
                companyId: null,
                userId: null
            };
        case actionTypes.LICENSE_SAVE_PRODUCT_LIST_ORDER:
            return {
                ...state,
                productListOrder: action.payload.productListOrder
            };
        case actionTypes.LICENSE_SAVE_PRODUCT_LIST:
            return {
                ...state,
                product: null,
                productList: modelHelper.mapLicenseProductsToObjectOrdered(
                    action.payload.productList,
                    state.productListOrder
                )
            };
        case actionTypes.LICENSE_SAVE_ONLINE_COUNTS:
            return {
                ...state,
                productList: modelHelper.updateLicenseProducts(state.productList, action.payload.counts)
            };
        case actionTypes.LICENSE_SET_PRODUCT:
            return {
                ...state,
                product: action.payload.product
            };
        case actionTypes.LICENSE_SET_DATA:
            return {
                ...state,
                data: action.payload.data
            };
        case actionTypes.SAVE_REGISTRATION_DATA:
            return {
                ...state,
                registrationData: modelHelper.mapRegistrationDataToObject(action.payload.registrationData)
            };
        case actionTypes.LICENSE_SAVE_ERROR:
            return {
                ...state,
                errorCode: action.payload.code
            };
        case actionTypes.WEBSOCKET_CLOSED:
            return initialState;
        default:
            return state;
    }
};
